/* eslint-disable react/no-array-index-key */
import PAImage from "component/design-system/images/PAImage";
import Link from "next/link";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";

interface Props {
    leftRightImages: Array<any>;
    imagesUrl: Array<string>;
    useVizSensor: unknown;
}

// http://localhost:3000/test-image-v2
function LeftRightImages({
  leftRightImages, imagesUrl, useVizSensor,
} : Props) {
  const isLeftRightImageInformationPresent = leftRightImages?.every((image: any) => image.imageUrl && image.url);
  const isImageUrlPresent = imagesUrl && imagesUrl.length !== 0;

  if (isLeftRightImageInformationPresent) {
    // https://dev.partsavatar.ca/ultimate-valentines-day-gift-guide#Gifts%20For%20Him
    return (
      <>
        {
          leftRightImages.map((image: any, index: any) => (
            (
              <Link
                href={image.url}
                key={index}
              >

                <PAImage
                  lazyLoad={useVizSensor}
                  src={`${getRelativeImagePath(`/cms/${image.imageUrl}`)}`}
                  width={250}
                  height={250}
                  alt={image.imageUrl}
                />

              </Link>
            )
          ))
        }
      </>
    );
  }
  if (isImageUrlPresent) {
    // https://dev.partsavatar.ca/brake-rotors-buying-guide#cast-iron-brake-rotors
    return (
      <>
        {
          imagesUrl.map((image: any, index: any) => (
            <div key={index}>
              <PAImage
                lazyLoad={useVizSensor}
                src={`${getRelativeImagePath(`/cms/${image}`)}`}
                width={250}
                height={250}
                alt={image}
              />
            </div>
          ))
        }
      </>
    );
  }
  return <></>;
}

export default LeftRightImages;
